import React from 'react';
import { Route, Navigate } from 'react-router-dom';

// Dead parent redirects and section entry-point aliases.
export const redirectsRoutes = (
  <>
    <Route path="/data" element={<Navigate to="/all-books" replace />} />
    <Route path="/wholesale" element={<Navigate to="/wholesale/operations" replace />} />
  </>
);
